export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <g transform="translate(21 10)" stroke="#979797" strokeWidth="2">
                    <rect x="1" y="1" width="32.438" height="55" rx="7" />
                    <path strokeLinecap="round" d="M1.188 20.75H33.25M6.692 33.549v6.107" />
                </g>
            </g>
        </svg>
    );
}
